export default __webpack_public_path__ + "static/media/41.36278ed7.png";